import { Component ,OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { FaqService } from '../../service/faq.service';
import { RoleplayApiService } from '../../service/roleplay.service';
import { DatePipe } from '@angular/common';
import { CreateChatReqRes } from '../../model/chat.model';
import { CreateRolePlayQuestionAnswerRequest, RoleplayCardInfo } from '../../model/rolePlay'
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TraineeSummary } from '../../model/rolePlay.model';
import { TraineeListService } from '../../service/trainee-list.service';
import { ConstantConfig } from '../../utility/constant-config';
import { PlatformRegionService } from '../../service/shared/platform-region.service';

@Component({
    selector: 'app-trainer-assigned-roleplay',
    templateUrl: './trainer-assigned-roleplay.component.html',
    styleUrl: './trainer-assigned-roleplay.component.scss',
    standalone: false
})
export class TrainerAssignedRoleplayComponent implements OnInit {
  config: any = ConstantConfig;
  conversation: any[] = [];
  currentTime: any;
  currentIndex: number = 0;
  userAnswer: string = '';
  userId: number;
  conversationHistory: any[] = []; // Array to store conversation history
  @ViewChild('scrollMe') private myScrollContainer!: ElementRef;
  showOverlayContent: boolean = false;
  showOverlay: boolean = false;
  editEnabled: boolean = false;
  abioRolePlayResponse: number;

  topic:boolean=true;
  toggleFirstSecond = 0;
  creatChatSubscription: any = new Subscription();
  dataObject: any = {
    chat_session_id: 0
  }
  receivedData: number = 0;
  score: number = 0;
  session_id: number = 0;
  selectedUserId: number = 0;
  feedback_id: number = 0;
  user_id: number;
  feedbackRequest: any = {     
  };
  feedbackData: string = "";
  isVisible: boolean = false;
  givenName:string = "";
  roleplayInfo: RoleplayCardInfo;
  DrName:string = "";
  wwidParam: number = 0;
  chatType: string = '';
  traineeDetails: TraineeSummary;
  drName: string;
  first_name: any;
  last_name: any;
  subscription: Subscription;
  totalTrainerCount: any;
  items: any[];
  scenarioId: any;
  scenarioName: any;

  constructor( private toastr: ToastrService, public TraineeService: TraineeListService, private activateRoute: ActivatedRoute, public Router: Router, private route: ActivatedRoute, private rolePlayService: RoleplayApiService, private apiService: FaqService,
     private datePipe: DatePipe,private renderer: Renderer2, private TraineeList: TraineeListService,
    private platformRegionService: PlatformRegionService) { }
  ngOnInit(): void {
    this.givenName = sessionStorage.getItem("givenName");
    this.userId = Number(sessionStorage.getItem('userId'));
    const inputFooter = document.getElementById('input-footer');
    const feedbackFooter = document.getElementById('feedback-footer');
    inputFooter.style.display = 'none';
    feedbackFooter.style.display = 'block';
    this.route.paramMap.subscribe(params => {
      this.session_id = +params.get('sessionId'); // Retrieve the dynamic data
      this.selectedUserId = +params.get('selectedUserId'); // Retrieve the dynamic data
      this.first_name = params.get('firstName'); // Retrieve the dynamic data
      this.last_name = params.get('lastName'); // Retrieve the dynamic data
    });
    this.rolePlayService.getTrainerFeedback(this.session_id).subscribe((data: any) => {

      if (data.length) {
      this.feedback_id = data[0].id;
      this.score = data[0].avg_response_score;
      const trainer_feedback = data[0].trainer_feedback;
      if (trainer_feedback && trainer_feedback !== null && trainer_feedback !== 'NA') {
        this.feedbackData =  trainer_feedback
      } else {
        this.feedbackData = `You have completed the Roleplay session!`; //Your score is ${this.score} %
      } 
    }     
      
    })
    this.rolePlayService.getChatHistory(this.session_id).subscribe((data: any) => {

      let data1 = data.conversations;
      this.DrName = data.dr_name;
      this.chatType = data.chat_type; 
      if (data1.length) {
        this.conversation = data1.map(entry => ({
          question: entry.user_request,
          answer: entry.bot_response,
          cssClass: 'bot',
          request_time: this.convertUtcToLocal(entry.request_time), // Formatted as 'hh:mm a MMM dd'
      response_time: this.convertUtcToLocal(entry.response_time)
        }));
      }
      this.scenarioId = data1[0].roleplay_scenario_id;
      this.scenarioName = data.scenario_name;
      this.loadData(this.scenarioId);
    })

    
    // this.rolePlayService.visibility$.subscribe(
    //   (isVisible) => this.isVisible = isVisible
    // );
    // this.getCurrentTime();
    // this.createChatSession();
    // setTimeout(() => {
    //   this.scrollToBottom();
    // }, 300);
    // this.rolePlayService.setRoleplayInfoSidebar$.subscribe((data) => {
    //   if(data.scenario_id && data.scenario_name !== "") {
    //     this.roleplayInfo = data;
    //   }
    // });
  }
  convertUtcToLocal(utcDateString: string): Date | null {
    return new Date (this.datePipe.transform(utcDateString.split('.')[0] + 'Z','yyyy-MM-dd HH:mm:ss'));
  }
  enableEdit() {
        this.editEnabled = true;
  }

  backbutton() {
    this.Router.navigate(['/app-trainee-detail'], { skipLocationChange: true, queryParams: {id: this.selectedUserId} });
  }

  loadData(loginId): void {
    this.subscription = this.TraineeList.getScenarioToTrainerbyId(loginId).subscribe({
      next: (response) => {
        if(response.length > 0) {
          this.totalTrainerCount = response.length;
          this.items = response.map((item)=> {
            const foundElements = item.meta_data.filter(element => element['roleplay_metadata_type'] === 'objectives');
            item.objectives = foundElements.map(element => element['roleplay_metadata_val']);
          });
        }
        this.items = response;
      },
      error: (error) => {
        console.error('Error fetching objectives data', error);
      }
    });
  }
  
  submitFeedback() {
    if (this.feedbackData != '') {
      const createTrainerFeedbackRequest = {
        trainer_feedback: this.feedbackData
      }
      this.rolePlayService.updateTrainerFeedback(this.feedback_id, createTrainerFeedbackRequest).subscribe((data: any[]) => {
        const message = "Feedback saved Successfully";
        this.toastr.success(message, '', { positionClass: 'toast-top-right' });
        this.editEnabled = false;

      });
    } else {
      const message1 = "Please enter the Feedback"
      this.toastr.warning(message1, '', { positionClass: 'toast-top-right' });
    }
  }
  
  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) { }
  }
  createChatSession() {
    const currentTime = new Date().toISOString();
    const profile = JSON.parse(sessionStorage.getItem("profile"));
    this.user_id = +profile.id;
    let chatRequest: CreateChatReqRes = {
      chat_topic: `scenario_${this.receivedData}`,
      chat_name: "role-play",
      chat_user_id: this.userId,
      chat_end_time: currentTime,
      chat_start_time: currentTime,
      chat_type: "role-play",
      business_unit_code: this.platformRegionService.selected_platform_code,
      region_name: this.platformRegionService.selected_region_code,
      primary_market: this.platformRegionService.selected_market_code,
      product: this.platformRegionService.selected_platform_code,
    }
    this.creatChatSubscription = this.apiService.createChatSession(chatRequest)
    .subscribe((res: CreateChatReqRes) => {
      this.dataObject.chat_session_id = res.chat_session_id;
      this.feedbackRequest = {
        chat_user_id: this.userId,
        chat_session_id: res.chat_session_id,
        scenario_id: this.receivedData
    } 
    });

  }
  getCurrentTime() {
    const now = new Date();
    this.currentTime = this.datePipe.transform(now, 'h:mm a');
  }
  getNextQuestion() {
    if(this.userAnswer.trim() == "") {
      return;
    }
    this.showOverlay = false; 
      let questionRequest: CreateRolePlayQuestionAnswerRequest = {
        chat_session_id: this.dataObject.chat_session_id,
        scenario_id: this.receivedData,
        user_request: this.userAnswer,
        business_unit_code: sessionStorage.getItem('businessUnitCode')   
      }
      this.userAnswer = '';
      this.showLoader();

      this.rolePlayService.getQuestionAnswer(questionRequest).subscribe((data: any) => {
        let conversationData = {
          question: data.user_request,
          answer: data.llm_response
        }
        this.hideLoader();
        this.conversation.push(conversationData);
        const chatBox = document.getElementById('chat-box');
        chatBox.scrollTop = chatBox.scrollHeight;  // Auto-scroll to the bottom
        this.showOverlayContent  = true;
      });
    
    if (this.userAnswer.trim() !== '') {
      if(this.topic){
        this.topic=false;
      }else{
          // Save the current question and user answer to conversation history
      this.conversationHistory.push({
        bot_question: this.conversation[this.currentIndex].bot_question,
        answer: this.userAnswer
      });
    }
      // Save the current question and user answer to conversation history
      this.conversationHistory.push({
        bot_question: this.conversation[this.currentIndex].bot_question,
        answer: this.userAnswer
      });
      //this.sendUserAnswer(this.userAnswer);
      this.userAnswer = ''; // Clear the user answer
    }
    this.currentIndex++;
  }

  handleResponse(response: number) {
    this.abioRolePlayResponse = response;
    this.showOverlay = false;
    this.feedbackRequest = {
        chat_user_id: this.userId,
        chat_session_id: this.dataObject?.chat_session_id,
        scenario_id: this.receivedData
    } 
    this.showFeedback();
    // alert(this.abioRolePlayResponse)
  }

  showLoader() {
    const loader = document.getElementById('loader');
    loader.style.display = 'inline-block';
  }

  showFeedback() {
    const inputFooter = document.getElementById('input-footer');
    const feedbackFooter = document.getElementById('feedback-footer');
    inputFooter.style.display = 'none';
    feedbackFooter.style.display = 'block';
    const chatBox = document.getElementById('chat-box');
    const middlePosition = chatBox.scrollHeight / 2 - chatBox.clientHeight / 3;    
    chatBox.scrollTop = middlePosition;
  }
  
  hideLoader() {
    const loader = document.getElementById('loader');
    loader.style.display = 'none';
  }
  

  getPreviousQuestion() {
    this.currentIndex--;
  }
  hideOverlay() {
    this.showOverlay = false; // Hide the overlay
  }
}
